module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABQ0lEQVQ4T+2UP0sDQRDF39vGIAbFzyKCIkSwstZGLL29i4IKSRBiIYr4pxEsFOXdB9DGOoVNGj9JSisJCEbJyBVKcnoXhXQ65b7d376dnRliyMEh8/AFGATBmnOuAmAy6zIzewFwG8dxHYD17usDeu9nST78wvWmpItMYBRFZTM7AnAJ4NnMvk1Jsu6cWwFwI+k4z2GF5ISkvUEuvfeLJKclHWQCwzCsAhj/CTCKogUzm/sH9tfhH8yh975GckzS/qA6DIJg3jlXGlQ26wCWut3uaqfTefuAFotFtNvtvjsKhULSx0+SDvMKOwJwnXZnZk2SMwBGUlpd0mle65VJXqUO3Ula9t5vkzzv1cxsN47jkzxgiWQzBXw0syrJLQBTKa0m6SwTmAhhGO4ASJ4+mvMxrwDuW63WRqPRSGbjZwx9Yr8DG2y2FRjnkGAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sh_login_icon_tel.png
// module id = 3u9e
// module chunks = 1